<script setup>
const props = defineProps({
  // 是否动态计算高度
  computedHeight: {
    type: Boolean,
    default: true,
  },
})
const stickyBox = ref(null)

const height = computed(() => {
  return props.computedHeight ? (stickyBox.value?.offsetHeight || 0) : 0
})
</script>

<template>
  <div :style="{ height: `${height}px` }">
    <div
      ref="stickyBox"
      class="sticky-bottom"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.module.scss";
</style>
